import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TellentAnalytics } from '@core/tellent-util';

@Injectable({ providedIn: 'root' })
export class AddMemberAnalyticsService extends TellentAnalytics {
  public readonly namespace = 'AddMemberDialog';

  public route = inject(ActivatedRoute);

  public trackDialogOpened(context?: string): void {
    const params = this.route.snapshot.queryParams;
    this.track('DialogOpen', {
      opened_from: params.viewContext || context,
    });
  }

  public trackSent(addQuantity: number, recruitee: false | string, kiwi: false | string) {
    this.track('Sent', {
      add_quantity: addQuantity,
      recruitee,
      kiwi,
    });
  }
}
